/**
 * Page Loader Component
 *
 * A minimal, clean loading component for lazy-loaded pages.
 * Features a smooth progress bar animation.
 */

import React, { memo, useState, useEffect } from 'react';
import '../styles/PageLoader.css';

/**
 * PageLoader - Minimal loading screen for lazy-loaded routes
 *
 * @param {Object} props - Component props
 * @param {string} [props.message='Loading'] - Loading message to display
 * @returns {JSX.Element} PageLoader component
 */
const PageLoader = memo(({ message = 'Loading' }) => {
  const [dots, setDots] = useState('');

  // Animate the dots in the loading message
  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => prev.length >= 3 ? '' : prev + '.');
    }, 400);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="page-loader">
      <div className="page-loader-content">
        {/* Loading text */}
        <div className="page-loader-text">
          <span className="page-loader-message">{message}</span>
          <span className="page-loader-dots">{dots}</span>
        </div>

        {/* Shimmer bar */}
        <div className="page-loader-bar">
          <div className="page-loader-bar-fill" />
        </div>
      </div>
    </div>
  );
});

PageLoader.displayName = 'PageLoader';

export default PageLoader;
